<template>
    <div class="bg-gray-100 overflow-hidden rounded-lg">
        <div class="px-4 py-5 sm:p-6">
            <slot />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppWell',
};
</script>
